module.exports = __webpack_public_path__ + "static/img/Partition_001.95bd8850.png";